import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";
import { useI18n } from "../../contexts";
const LearnMoreTag = (param)=>{
    let { url, style = undefined, label } = param;
    const { __ } = useI18n();
    const useStyle = {
        cursor: "pointer",
        ...style
    };
    return /*#__PURE__*/ _jsxs(Tag, {
        style: useStyle,
        onClick: ()=>window.open(url, "_blank"),
        children: [
            /*#__PURE__*/ _jsx(QuestionCircleFilled, {}),
            " ",
            label || __("Learn more")
        ]
    });
};
export { LearnMoreTag };
